import { MDXProvider } from "@mdx-js/react";
import React from "react";

import ContentImage from "./ContentImage";
import ContentVideo from "./ContentVideo";
import Figure from "./Figure";
import MarkdownElements from "./MarkdownElements";
import MediaEntry from "./MediaEntry";
import Monogram from "./Monogram";

const CustomMDXProvider: React.FC<React.PropsWithChildren> = ({ children }) => (
  <MDXProvider
    components={{
      ContentImage,
      ContentVideo,
      Figure,
      MediaEntry,
      ...MarkdownElements,
      Monogram,
    }}
  >
    {children}
  </MDXProvider>
);

export default CustomMDXProvider;
